import authRules from '../authRules';

const viewTourSalaryLevel = (user) => {
  const { updateSalaryLevelInApprovals } = user.securityLevels;
  if (updateSalaryLevelInApprovals >= authRules.viewTourSalaryLevel.updateSalaryLevelInApprovals) {
      return true;
  } else {
      return false;
    }
  }


export default viewTourSalaryLevel;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewTourSalaryLevel.js